import React from 'react'
import Image from 'next/image'
import cn from 'classnames'

import { Box } from '@features/story/components/Box'
import { Button } from '@components/Buttons'
import { BookLinkProps } from './interface'

export const BookLink = ({
  naiinCoverImgPath,
  naiinTitle,
  naiinCover,
  naiinLink,
  bookLinks,
  className,
  isDrawer = false,
}: BookLinkProps) => {
  return (
    <Box className={cn('card dark:border-purple', className)}>
      <Box.Title className='text-2xl dark:text-dark-10'>
        โปรโมทหนังสือ/อีบุ๊กที่ขายกับนายอินทร์
      </Box.Title>

      <div
        className={cn('flex mt-5 mobile:flex-col mobile:mt-[10px]', {
          'space-x-[37px] mobile:space-x-0': !isDrawer,
          'space-x-[20px] mobile:space-x-0': isDrawer,
        })}
      >
        <div
          className={cn('relative', {
            'w-[144px] h-[202px]': !isDrawer,
            'w-[161px] h-[226px] mobile:w-[144px] mobile:h-[202px]': isDrawer,
          })}
        >
          <Image
            className='h-full w-full rounded-lg object-cover'
            src={naiinCoverImgPath}
            alt={naiinTitle}
            layout='fill'
          />
        </div>

        <div className='flex flex-col flex-1 mobile:mt-[20px]'>
          <Box.Label className='text-xs mb-[5px]'>ชื่อเรื่อง</Box.Label>
          <Box.Text className='dark:text-dark-10'>{naiinTitle}</Box.Text>

          <Box.Label className='text-xs mt-5 mb-[5px]'>คำโปรย</Box.Label>
          <Box.Text
            className={cn('break-word leading-[1.8] dark:text-dark-10', {
              'line-clamp-2 mobile:line-clamp-4': !isDrawer,
              'line-clamp-3 mobile:line-clamp-4': isDrawer,
            })}
          >
            {naiinCover}
          </Box.Text>

          <Button
            type='button'
            className='bg-primary dark:bg-purple mt-auto w-[178px] h-10 mobile:mt-[20px]'
            onClick={() => {
              if (naiinLink) {
                window.open(naiinLink, '_blank')
              }
            }}
          >
            <span className='font-mitr font-medium text-sm text-white dark:text-white-2'>
              ซื้อเลย
            </span>
          </Button>
        </div>
      </div>

      {/* {!!bookLinks?.length && (
        <div className='flex flex-col mt-[50px] mobile:mt-[40px]'>
          <Box.Title className='text-2xl mb-[20px]'>
            สั่งจองหนังสือรูปเล่ม
          </Box.Title>

          <div className='grid grid-cols-[fit-content(30%)_auto] gap-x-[40px] gap-y-[20px] mobile:grid-cols-1 mobile:gap-y-[10px]'>
            {bookLinks.map((bookLink, index) => (
              <>
                <Box.Text
                  className={cn('truncate', {
                    'mobile:pt-[10px]': index !== 0,
                  })}
                >
                  {bookLink.detail}
                </Box.Text>
                <a
                  className='cursor-pointer font-light text-primary underline truncate'
                  href={bookLink.link}
                  target='_blank'
                  rel='noreferrer'
                >
                  {bookLink.link}
                </a>
              </>
            ))}
          </div>
        </div>
      )} */}
    </Box>
  )
}
